import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

/**
 * Fires a pageview ping on every route change. Mount once near the top
 * of the app tree (inside a router context). Errors are swallowed by
 * api.pingPageview so a logging failure can't break navigation.
 *
 * Pre-login routes (/login, /register, /verify-otp) still ping —
 * useful for the Control Centre to see login funnel volume. The
 * backend stores NULL user_id when the request has no valid session.
 */
export function usePageviewTracker() {
  const location = useLocation();
  useEffect(() => {
    void api.pingPageview(location.pathname);
  }, [location.pathname]);
}
